<template>
	<div class="row q-col-gutter-lg">
		<div id="circularProgressContainer">
			<CircularProgress />			
		</div>
		<div class="col-xs-8" id="pageTitleContainer">
			<div class="text-h4 text-weight-bold" id="pageTitle">{{ $t(title) }}</div>
			<div v-if="description" class="q-py-xs" id="pageDescription">{{ $t(description) }}</div>
		</div>
	</div>
	<q-separator class="q-my-md" id="separator" />
	<div v-if="visitDetails" class="q-gutter-xs" id="pageContent">
		<q-field
			v-if="visitDetails.locationName"
			:label="$t('portal_visitLocation')"
			stack-label
			borderless
			id="pageField"
		>
			<template v-slot:control>
				<div class="self-center full-width no-outline" id="pageFieldValue">
					{{ visitDetails.locationName }}
				</div>
			</template>
		</q-field>
		<q-field
			v-if="visitDetails.entryDateLocal"
			:label="$t('portal_entryDate')"
			stack-label
			borderless
			id="pageField"
		>
			<template v-slot:control>
				<div class="self-center full-width no-outline" id="pageFieldValue">
					<span class="date-value">{{ portal.getFormattedDate(visitDetails.entryDateLocal) }}</span><span class="local-time">{{' ('+ $t('portal_localTime') + ')' }}</span>
				</div>
			</template>
		</q-field>
		<q-field
			v-if="visitDetails.exitDateLocal"
			:label="$t('portal_exitDate')"
			stack-label
			borderless
			id="pageField"
		>
			<template v-slot:control>
				<div class="self-center full-width no-outline" id="pageFieldValue">
					<span class="date-value">{{ portal.getFormattedDate(visitDetails.exitDateLocal) }}</span><span class="local-time">{{' ('+ $t('portal_localTime') + ')' }}</span>
				</div>
			</template>
		</q-field>
		<q-field
			v-if="visitDetails.escortName"
			:label="$t('portal_escort')"
			stack-label
			borderless
			id="pageFieldValue"
		>
			<template v-slot:control>
				<div class="self-center full-width no-outline" id="pageFieldValue">
					{{ visitDetails.escortName }}
				</div>
			</template>
		</q-field>
		<q-field
			v-if="visitDetails.notes"
			:label="$t('portal_notes')"
			stack-label
			borderless
			id="pageField"
		>
			<template v-slot:control>
				<div class="self-center full-width no-outline" id="pageFieldValue">
					{{ visitDetails.notes }}
				</div>
			</template>
		</q-field>
	</div>
</template>

<style lang="less" scoped src="./visit-details.less"></style>
<script lang="ts" src="./visit-details.ts"></script>
